import React, { useState } from 'react';
import { IconButton, InputAdornment, TextField } from '@mui/material';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import VisibilityOffOutlinedIcon from '@mui/icons-material/VisibilityOffOutlined';
import { textFieldStyle } from './AuthStyles';

const AuthPasswordField = ({
  label = 'Password',
  value,
  onChange,
  required = false,
  disabled = false,
  autoComplete = 'current-password',
  error = false,
  helperText = '',
  id,
}) => {
  const [showPassword, setShowPassword] = useState(false);

  return (
    <TextField
      id={id}
      fullWidth
      margin="normal"
      label={label}
      type={showPassword ? 'text' : 'password'}
      value={value}
      onChange={onChange}
      required={required}
      disabled={disabled}
      autoComplete={autoComplete}
      error={Boolean(error)}
      helperText={helperText || undefined}
      sx={textFieldStyle}
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            <IconButton
              aria-label={showPassword ? 'Hide password' : 'Show password'}
              onClick={() => setShowPassword((prev) => !prev)}
              onMouseDown={(event) => event.preventDefault()}
              edge="end"
              size="small"
              disabled={disabled}
              sx={{ color: 'text.secondary' }}
            >
              {showPassword ? (
                <VisibilityOffOutlinedIcon sx={{ fontSize: 20 }} />
              ) : (
                <VisibilityOutlinedIcon sx={{ fontSize: 20 }} />
              )}
            </IconButton>
          </InputAdornment>
        ),
      }}
    />
  );
};

export default AuthPasswordField;
